// a function to retry loading a chunk to avoid chunk load error for out of date code
const lazyRetry = async function (componentImport: () => Promise<any>) {
	const stringifiedFunction = componentImport.toString();
	const componentsRefreshed: string[] =
		JSON.parse(sessionStorage.getItem('reloaded-components')) || [];
	let refreshedComponents: Set<string>;

	if (Array.isArray(componentsRefreshed)) {
		refreshedComponents = new Set(componentsRefreshed);
	} else {
		throw Error('Unexpected value from data store');
	}

	const hasComponentRefreshed = refreshedComponents.has(stringifiedFunction);

	try {
		const component = await componentImport();
		refreshedComponents.delete(stringifiedFunction);
		sessionStorage.setItem(
			'reloaded-components',
			JSON.stringify(Array.from(refreshedComponents))
		);
		return component;
	} catch (error) {
		if (!hasComponentRefreshed) {
			refreshedComponents.add(stringifiedFunction);
			sessionStorage.setItem(
				'reloaded-components',
				JSON.stringify(Array.from(refreshedComponents))
			);
			location.reload();
		} else {
			throw error;
		}
	}
};

export { lazyRetry };
